export const url =
  process.env.NODE_ENV === "production"
    ? "https://twika-apis.onrender.com"
    : // : "https://twika-apis.onrender.com";
      // ? "https://twika-backend.herokuapp.com"
      "https://twika-apis.onrender.com";
// "http://localhost:4040";

export const cloudinary_url =
  "https://res.cloudinary.com/daubxzzj5/image/upload/v1623749098/twika/";

export const video_cloudinary_url =
  "https://res.cloudinary.com/daubxzzj5/video/upload/v1623749098/twika/";
